import React, { useState } from "react";
import { toast } from "react-toastify";

export default function PaymentForm({ initial = {}, onSubmit, onCancel }) {
  const [form, setForm] = useState({
    type: initial.type || "tarjeta",
    cardNumber: initial.cardNumber || "",
    expires: initial.expires || "",
    phone: initial.phone || "",
    holderName: initial.holderName || "",
    isDefault: initial.isDefault || false,
  });

  const handleChange = (field, value) => setForm({ ...form, [field]: value });

  const handleSubmit = (e) => {
    e.preventDefault();

    if (form.type === "tarjeta" && form.cardNumber.length < 12) {
      toast.error("Número de tarjeta inválido");
      return;
    }

    onSubmit(form);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-3">
      <div>
        <label className="text-sm text-gray-700">Tipo</label>
        <select
          value={form.type}
          onChange={(e) => handleChange("type", e.target.value)}
          className="w-full mt-1 p-3 border rounded-xl"
        >
          <option value="tarjeta">Tarjeta</option>
          <option value="bancolombia">Bancolombia</option>
          <option value="nequi">Nequi</option>
          <option value="daviplata">Daviplata</option>
          <option value="efectivo">Efectivo</option>
        </select>
      </div>

      {form.type === "tarjeta" ? (
        <>
          <div>
            <label className="text-sm text-gray-700">Número tarjeta</label>
            <input
              className="w-full mt-1 p-3 border rounded-xl"
              value={form.cardNumber}
              onChange={(e) => handleChange("cardNumber", e.target.value)}
            />
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="text-sm text-gray-700">Vence (MM/AA)</label>
              <input
                className="w-full mt-1 p-3 border rounded-xl"
                value={form.expires}
                onChange={(e) => handleChange("expires", e.target.value)}
              />
            </div>

            <div>
              <label className="text-sm text-gray-700">Titular</label>
              <input
                className="w-full mt-1 p-3 border rounded-xl"
                value={form.holderName}
                onChange={(e) => handleChange("holderName", e.target.value)}
              />
            </div>
          </div>
        </>
      ) : (
        <div>
          <label className="text-sm text-gray-700">Cuenta / Teléfono</label>
          <input
            className="w-full mt-1 p-3 border rounded-xl"
            value={form.phone}
            onChange={(e) => handleChange("phone", e.target.value)}
          />
        </div>
      )}

      <label className="flex items-center gap-2 text-sm">
        <input
          type="checkbox"
          checked={form.isDefault}
          onChange={(e) => handleChange("isDefault", e.target.checked)}
        />
        Marcar como método por defecto
      </label>

      <div className="flex justify-end gap-3 pt-2">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 rounded-xl border"
        >
          Cancelar
        </button>

        <button
          type="submit"
          className="px-4 py-2 rounded-xl bg-supernova-500 text-white"
        >
          Guardar
        </button>
      </div>
    </form>
  );
}
